export enum FinancialCategoryTypeEnum {
    DEBIT = 'DEBIT',
    CREDIT = 'CREDIT',
}
